import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import hapanaLogoFull from '@hapana/shared/web/styles/assets/images/hapana-logo-green-full.png'
import hapanaPattern from '@hapana/shared/web/styles/assets/images/hapana-pattern.png'

const BrandNotFound = () => {
  const { t } = useTranslation('core')
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        backgroundColor: 'info.lightest',
        overflow: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          position: 'relative',
          gap: { xs: 3, sm: 5 },
          px: 3,
          py: 5,
        }}
      >
        <Box
          component="img"
          alt="Hapana"
          src={hapanaLogoFull}
          sx={{ width: { xs: 160, sm: 216 }, zIndex: 1 }}
        />

        <Stack
          sx={{
            width: { xs: '100%', sm: 480 },
            backgroundColor: 'white',
            borderRadius: 4,
            border: '1px solid',
            borderColor: 'info.light',
            p: { xs: 3, sm: 5 },
            textAlign: 'center',
            alignItems: 'center',
            gap: 2,
            zIndex: 1,
          }}
        >
          <Typography typography="header2" color="primary.dark">
            {t('brandNotFound.title', { defaultValue: 'Brand not found' })}
          </Typography>

          <Typography typography="body" color="gray.64">
            {t('brandNotFound.description', {
              defaultValue: "We couldn't find a Hapana account at",
            })}{' '}
            <Box component="span" sx={{ fontWeight: 600, color: 'gray.90' }}>
              {hostname}
            </Box>
            {'. '}
            {t('brandNotFound.checkUrl', {
              defaultValue: 'Please double-check your URL and try again.',
            })}
          </Typography>

          <Box
            sx={{
              width: '100%',
              backgroundColor: 'info.lightest',
              borderRadius: 2,
              px: 2,
              py: 1.5,
            }}
          >
            <Typography
              typography="small"
              color="gray.64"
              sx={{ fontFamily: 'monospace', wordBreak: 'break-all' }}
            >
              {typeof window !== 'undefined' ? window.location.origin : ''}
            </Typography>
          </Box>

          <Typography typography="small" color="gray.48">
            {t('brandNotFound.contactAdmin', {
              defaultValue:
                'If you believe this is an error, please contact your Hapana administrator.',
            })}
          </Typography>
        </Stack>

        <Box
          sx={{
            backgroundImage: `url(${hapanaPattern})`,
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
            position: 'absolute',
            height: 248,
            width: '100%',
            bottom: 0,
            left: 0,
            right: 0,
            display: { xs: 'none', sm: 'block' },
          }}
        />
      </Box>
    </Box>
  )
}

export default BrandNotFound
